<template>
  <v-layout row justify-center>
    <v-dialog v-model="show" persistent max-width="700">
      <v-card>
        <v-card-title class="headline">Finalizar contrato</v-card-title>
        <v-card-text class="py-0">
          <v-layout row wrap>
            <v-flex xs12>
              <v-select v-model="terminationType" :items="terminationTypeItems" :error-messages="terminationTypeErrors" label="Tipo"
                        required @change="$v.terminationType.$touch()" no-data-text="No hay datos disponibles"></v-select>
            </v-flex>
            <v-flex xs12 px-2>
              <v-textarea v-model="description" label="Descripción"></v-textarea>
            </v-flex>
            <v-flex xs12 px-2>
              <transferencia-create v-if="$store.getters.isClubRole" v-show="terminationType==1"
                ref="transferenciaCreate" :isRequired="terminationType===1">
              </transferencia-create>
            </v-flex>
            <v-flex xs12>
              <AttachFile ref="fileInput" @upload="uploadFiles" single-file></AttachFile>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" flat @click="show = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <p class="red--text mr-3" v-for="error in fileErrors" :key="error">{{ error }}</p>
          <v-btn v-if="terminationType !== 2" color="primary" flat @click="openFileDirectory" :disabled="saving">Adjunto</v-btn>
          <v-btn color="primary" flat @click="uploadAllFiles" :disabled="saving">Finalizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { requiredIf } from 'vuelidate/lib/validators'
import AttachFile from '../../../common/ui/AttachFile'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import TransferenciaCreate from './TransferenciaCreate.vue'

export default {
  mixins: [validationMixin, s3UploadMixin],

  validations () {
    return {
      terminationType: { required: requiredIf(() => { return this.show })
      },
      files: {
        required: requiredIf(
          function () {
            if (this.terminationType !== 2) {
              return this.show
            } else {
              return false
            }
          })
      }
    }
  },

  components: {
    AttachFile,
    TransferenciaCreate
  },

  props: {
    isRequired: Boolean
  },

  data () {
    return {
      show: false,
      description: '',
      files: [],
      terminationType: null,
      terminationTypeItems: [
        {
          text: 'Rescisión',
          value: 0
        },
        {
          text: 'Transferencia',
          value: 1
        },
        {
          text: 'Renegociación de contrato',
          value: 2
        }
      ],
      saving: false
    }
  },

  computed: {
    fileErrors () {
      const errors = []
      if (!this.$v.files.$dirty && this.terminationType !== 2) return errors
      !this.$v.files.required && errors.push('Adjunto requerido.')
      return errors
    },
    terminationTypeErrors () {
      const errors = []
      if (!this.$v.terminationType.$dirty) return errors
      !this.$v.terminationType.required && errors.push('El tipo es requerido.')
      return errors
    },
    esTransferenciaEntreClubesLPF () {
      return this.terminationType === 1 && this.$refs.transferenciaCreate.clubPerteneceALPF
    },
    clubDestino () {
      return this.$refs.transferenciaCreate.clubDestino
    },
    clubDestinoNoLpf () {
      return this.$refs.transferenciaCreate.clubDestinoNoLpf
    },
    esTransferenciaClubNoLpf () {
      return this.terminationType === 1 && !this.$refs.transferenciaCreate.clubPerteneceALPF
    }
  },

  methods: {
    showDialog () {
      this.show = true
    },
    uploadFiles (newFiles) {
      this.files = newFiles
    },
    openFileDirectory () {
      this.$refs.fileInput.onPickFile()
    },
    getPayload () {
      const payload = {
        'contract': this.$route.params.id,
        'description': this.description,
        'type': this.terminationType,
        'asset': this.assets
      }
      if (this.esTransferenciaEntreClubesLPF) {
        payload.clubLpfDestino = this.clubDestino
      }
      if (this.esTransferenciaClubNoLpf) {
        payload.clubTo = this.clubDestinoNoLpf
      }
      return payload
    },
    isValidForm () {
      if (this.terminationType === 1) {
        this.$refs.transferenciaCreate.$v.$touch()
      }
      if (this.terminationType === 1) {
        return !this.$v.$invalid && !this.$refs.transferenciaCreate.$v.$invalid
      }
      return !this.$v.$invalid
    },
    submit () {
      this.$v.$touch()
      if (this.isValidForm()) {
        this.saving = true
        let payload = this.getPayload()
        this.axios
          .post('termination/new', payload)
          .then(() => {
            this.$router.go()
            this.saving = false
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.saving = false
          })
      }
    }
  }
}
</script>

<style scoped>

</style>
